/* External dependencies */
import { from, of } from "rxjs";
import { ofType } from "redux-observable";
import CognitoClient from "@mancho.devs/cognito";
import { mergeMap, catchError, tap, ignoreElements, switchMap, map } from "rxjs/operators";  
import { signOut, signInWithRedirect, signIn } from "aws-amplify/auth";

/* Local dependencies */
import { AuthActionTypes, logoutErrorAction, logoutSuccessAction, signInWithCognitoErrorAction, signInWithCognitoSuccessAction, signOutWithCognitoSuccessAction, signOutWithCognitoErrorAction } from "./actions";
import { authModalAction } from "../../../components/web-app/components/modal/redux/action";
import { unsubscribeDeviceAction } from "../../../components/devices/subscribe-device/redux/actions";

const email = 'xiyodoh368@minduls.com';
const password = 'Password123!';

export const loginWithGoogleEpic = (action$) =>
  action$.pipe(
    ofType(AuthActionTypes.LOGIN_WITH_GOOGLE_REQUEST),
    tap(() => {
      signInWithRedirect({ provider: 'Google' });
    }),
    ignoreElements(),
  );

export const logoutEpic = (action$) => action$.pipe(
  ofType(AuthActionTypes.LOGOUT_REQUEST),
  mergeMap(() =>
    from(signOut()).pipe(
      mergeMap(() => of(logoutSuccessAction(), unsubscribeDeviceAction())),
      catchError((error) => of(logoutErrorAction(error)))
    )
  )
);

export const signInWithCognitoEpic = (action$) =>
  action$.pipe(
    ofType(AuthActionTypes.SIGN_IN_WITH_COGNITO_REQUEST),
    switchMap(() =>
      from(signIn({
        username: email,
        password: password,
      })).pipe(
        mergeMap((result) => [signInWithCognitoSuccessAction(result), authModalAction(false)]),
        catchError((error) => of(signInWithCognitoErrorAction(error))),
        ),
      )
  );

export const signOutWithCognitoEpic = (action$) =>
  action$.pipe(
    ofType(AuthActionTypes.SIGN_OUT_WITH_COGNITO_REQUEST),
    switchMap(() => {
      return from(signOut({
        global: true,
      })).pipe(
        mergeMap(() => [signOutWithCognitoSuccessAction(), authModalAction(false)]),
        catchError((error) => of(signOutWithCognitoErrorAction(error))),
      )
    }),
  );
